module.exports = __webpack_public_path__ + "img/logo_big.f9251810.png";